export default {
      id: "FunctionUpperLimbBilateral-usage",
      viewBox: "0 0 54 54",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#FunctionUpperLimbBilateral",
      toString: function () {
        return this.url;
      }
    }